<script>
export default {
    props: {
        value: Boolean,
        checked: Boolean,
        readonly: Boolean,
        label: String,
    },
    created() {
        if (this.$options.propsData.value) {
            this.localValue = this.value;
        } else if (this.$options.propsData.checked) {
            this.localValue = this.checked;
        }
    },
    data: () => ({
        localValue: false,
    }),
    methods: {
        toggle() {
            if (!this.readonly) {
                this.localValue = !this.localValue;
            }
        },
    },
    watch: {
        value(nextVal) {
            this.localValue = this.value;
        },
        checked(nextVal) {
            this.localValue = this.checked;
        },
        localValue(nextVal) {
            this.$emit('input', nextVal);
        },
    },
};
</script>

<template>
<div :class="['Checkbox', {Checked: localValue}]" @click="toggle()">
    <div class="Box">
        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="16.5" height="13.5" viewBox="0 0 16.5 13.5" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.038 2.741c.298-.305.462-.708.462-1.133 0-.43-.164-.833-.462-1.138a1.55 1.55 0 00-2.222 0L4.869 9.616 2.684 7.385a1.548 1.548 0 00-2.222 0A1.614 1.614 0 000 8.522c0 .429.164.832.462 1.133l3.293 3.365a1.55 1.55 0 002.222 0"/></svg>
    </div>
    <div class="Label"><slot>{{ label }}</slot></div>
</div>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

.Checkbox
    display flex
    align-items center
    color $cPrimary
    cursor pointer
    .Box
        border 1px solid $cBorder
        height 28px
        width 28px
        margin-right 15px
        display flex
        justify-content center
        align-items center
        flex 0 0 auto
        path
            fill $cAccent
            transition .3s all
            opacity 0
    .Label
        font-weight 600
        font-size 12px
        width 200px
    &.Checked .Box path
        opacity 1
</style>


